import type { CrmMessages } from "./englishCrmMessages";

export const germanCrmMessages = {
  resources: {
    companies: {
      name: "Unternehmen |||| Unternehmen",
      forcedCaseName: "Unternehmen",
      fields: {
        name: "Firmenname",
        website: "Website",
        linkedin_url: "LinkedIn-URL",
        phone_number: "Telefonnummer",
        created_at: "Erstellt am",
        nb_contacts: "Anzahl Kontakte",
        revenue: "Umsatz",
        sector: "Branche",
        size: "Größe",
        tax_identifier: "USt-IdNr.",
        address: "Adresse",
        city: "Ort",
        zipcode: "PLZ",
        state_abbr: "Bundesland",
        country: "Land",
        description: "Beschreibung",
        context_links: "Kontext-Links",
        sales_id: "Kundenbetreuer",
      },
      empty: {
        description: "Ihre Unternehmensliste ist offenbar leer.",
        title: "Keine Unternehmen gefunden",
      },
      import: {
        title: "Unternehmen importieren",
      },
      field_categories: {
        contact: "Kontakt",
        additional_info: "Weitere Informationen",
        address: "Adresse",
        context: "Kontext",
      },
      action: {
        create: "Unternehmen anlegen",
        edit: "Unternehmen bearbeiten",
        new: "Neues Unternehmen",
        show: "Unternehmen anzeigen",
      },
      added_on: "Hinzugefügt am %{date}",
      followed_by: "Betreut von %{name}",
      followed_by_you: "Von Ihnen betreut",
      no_contacts: "Keine Kontakte",
      nb_contacts: "%{smart_count} Kontakt |||| %{smart_count} Kontakte",
      nb_deals: "%{smart_count} Deal |||| %{smart_count} Deals",
      sizes: {
        one_employee: "1 Mitarbeiter",
        two_to_nine_employees: "2-9 Mitarbeiter",
        ten_to_forty_nine_employees: "10-49 Mitarbeiter",
        fifty_to_two_hundred_forty_nine_employees: "50-249 Mitarbeiter",
        two_hundred_fifty_or_more_employees: "250 oder mehr Mitarbeiter",
      },
      autocomplete: {
        create_error:
          "Beim Anlegen des Unternehmens ist ein Fehler aufgetreten",
        create_item: "%{item} anlegen",
        create_label: "Tippen Sie los, um ein neues Unternehmen anzulegen",
      },
    },
    contacts: {
      name: "Kontakt |||| Kontakte",
      forcedCaseName: "Kontakt",
      field_categories: {
        background_info: "Hintergrundinformationen",
        identity: "Identität",
        misc: "Sonstiges",
        personal_info: "Persönliche Daten",
        position: "Position",
      },
      fields: {
        first_name: "Vorname",
        last_name: "Nachname",
        last_seen: "Letzte Aktivität",
        title: "Funktion",
        company_id: "Unternehmen",
        email_jsonb: "E-Mail-Adressen",
        email: "E-Mail",
        phone_jsonb: "Telefonnummern",
        phone_number: "Telefonnummer",
        linkedin_url: "LinkedIn-URL",
        background: "Hintergrund (Kurzprofil, Kennenlernen usw.)",
        has_newsletter: "Newsletter abonniert",
        sales_id: "Kundenbetreuer",
      },
      action: {
        add: "Kontakt hinzufügen",
        add_first: "Ersten Kontakt hinzufügen",
        create: "Kontakt anlegen",
        edit: "Kontakt bearbeiten",
        export_vcard: "Als vCard exportieren",
        new: "Neuer Kontakt",
        show: "Kontakt anzeigen",
      },
      background: {
        last_activity_on: "Letzte Aktivität am %{date}",
        added_on: "Hinzugefügt am %{date}",
        followed_by: "Betreut von %{name}",
        followed_by_you: "Von Ihnen betreut",
        status_none: "Kein Status",
      },
      position_at: "%{title} bei",
      position_at_company: "%{title} bei %{company}",
      empty: {
        description: "Ihre Kontaktliste ist offenbar leer.",
        title: "Keine Kontakte gefunden",
      },
      import: {
        title: "Kontakte importieren",
      },
      inputs: {
        genders: {
          male: "Herr",
          female: "Frau",
          nonbinary: "Divers",
        },
        personal_info_types: {
          work: "Geschäftlich",
          home: "Privat",
          other: "Sonstige",
        },
      },
      list: {
        error_loading: "Fehler beim Laden der Kontakte",
      },
      bulk_tag: {
        action: "Tag zuweisen",
        create_description:
          "Erstellen Sie einen neuen Tag und weisen Sie ihn den ausgewählten Kontakten zu.",
        back: "Zurück zu den Tags",
        description:
          "Wählen Sie einen vorhandenen Tag oder erstellen Sie einen neuen für die ausgewählten Kontakte.",
        empty:
          "Noch keine Tags vorhanden. Erstellen Sie einen, um die ausgewählten Kontakte zu kennzeichnen.",
        error: "Der Tag konnte den Kontakten nicht zugewiesen werden",
        noop: "Die ausgewählten Kontakte haben diesen Tag bereits",
        success:
          "Tag zu %{smart_count} Kontakt hinzugefügt |||| Tag zu %{smart_count} Kontakten hinzugefügt",
        title: "Tag zu Kontakten hinzufügen",
      },
      merge: {
        action: "Mit einem anderen Kontakt zusammenführen",
        confirm: "Kontakte zusammenführen",
        current_contact: "Aktueller Kontakt (wird gelöscht)",
        description: "Führen Sie diesen Kontakt mit einem anderen zusammen.",
        error: "Die Kontakte konnten nicht zusammengeführt werden",
        merging: "Wird zusammengeführt...",
        no_additional_data: "Keine zusätzlichen Daten zum Zusammenführen",
        select_target: "Bitte wählen Sie einen Kontakt zum Zusammenführen aus",
        success: "Kontakte erfolgreich zusammengeführt",
        target_contact: "Zielkontakt (bleibt erhalten)",
        title: "Kontakt zusammenführen",
        warning_description:
          "Alle Daten werden auf den zweiten Kontakt übertragen. Diese Aktion kann nicht rückgängig gemacht werden.",
        warning_title: "Achtung: Daten werden unwiderruflich verändert",
        what_will_be_merged: "Das wird zusammengeführt:",
      },
      filters: {
        before_last_month: "Vor dem letzten Monat",
        before_this_month: "Vor diesem Monat",
        before_this_week: "Vor dieser Woche",
        managed_by_me: "Von mir betreut",
        search: "Name, Unternehmen suchen...",
        this_week: "Diese Woche",
        today: "Heute",
        tags: "Tags",
        tasks: "Aufgaben",
      },
      hot: {
        empty_change_status:
          'Ändern Sie den Status eines Kontakts, indem Sie eine Notiz zu diesem Kontakt hinzufügen und auf "Optionen anzeigen" klicken.',
        empty_hint: 'Kontakte mit dem Status "Hot" erscheinen hier.',
        title: "Hot-Kontakte",
      },
    },
    deals: {
      name: "Deal |||| Deals",
      fields: {
        name: "Name",
        description: "Beschreibung",
        company_id: "Unternehmen",
        contact_ids: "Kontakte",
        category: "Kategorie",
        amount: "Budget",
        expected_closing_date: "Voraussichtlicher Abschluss",
        stage: "Phase",
      },
      action: {
        back_to_deal: "Zurück zum Deal",
        create: "Deal anlegen",
        new: "Neuer Deal",
      },
      field_categories: {
        misc: "Sonstiges",
      },
      filters: {
        only_mine: "Nur Deals, die ich betreue",
      },
      archived: {
        action: "Archivieren",
        error: "Fehler: Deal wurde nicht archiviert",
        list_title: "Archivierte Deals",
        success: "Deal archiviert",
        title: "Archivierter Deal",
        view: "Archivierte Deals anzeigen",
      },
      inputs: {
        linked_to: "Verknüpft mit",
      },
      unarchived: {
        action: "Archivierung aufheben",
        error: "Fehler: Archivierung des Deals wurde nicht aufgehoben",
        success: "Archivierung des Deals aufgehoben",
      },
      updated: "Deal aktualisiert",
      empty: {
        before_create: "bevor Sie einen Deal anlegen.",
        description: "Ihre Deal-Liste ist offenbar leer.",
        title: "Keine Deals gefunden",
      },
      import: {
        title: "Deals importieren",
      },
      invalid_date: "Ungültiges Datum",
    },
    notes: {
      name: "Notiz |||| Notizen",
      forcedCaseName: "Notiz",
      fields: {
        status: "Status",
        date: "Datum",
        attachments: "Anhänge",
        contact_id: "Kontakt",
        deal_id: "Deal",
      },
      action: {
        add: "Notiz hinzufügen",
        add_first: "Erste Notiz hinzufügen",
        delete: "Notiz löschen",
        edit: "Notiz bearbeiten",
        update: "Notiz aktualisieren",
        add_this: "Diese Notiz hinzufügen",
      },
      sheet: {
        create: "Notiz erstellen",
        create_for: "Notiz für %{name} erstellen",
        edit: "Notiz bearbeiten",
        edit_for: "Notiz für %{name} bearbeiten",
      },
      deleted: "Notiz gelöscht",
      empty: "Noch keine Notizen",
      author_added: "%{name} hat eine Notiz hinzugefügt",
      you_added: "Sie haben eine Notiz hinzugefügt",
      me: "Ich",
      list: {
        error_loading: "Fehler beim Laden der Notizen",
      },
      note_for_contact: "Notiz für %{name}",
      stepper: {
        hint: "Öffnen Sie eine Kontaktseite und fügen Sie eine Notiz hinzu",
      },
      added: "Notiz hinzugefügt",
      inputs: {
        add_note: "Notiz hinzufügen",
        options_hint: "(Dateien anhängen oder Details ändern)",
        show_options: "Optionen anzeigen",
      },
      actions: {
        attach_document: "Dokument anhängen",
      },
      validation: {
        note_or_attachment_required:
          "Eine Notiz oder ein Anhang ist erforderlich",
      },
    },
    sales: {
      name: "Benutzer |||| Benutzer",
      fields: {
        first_name: "Vorname",
        last_name: "Nachname",
        email: "E-Mail",
        administrator: "Administrator",
        disabled: "Deaktiviert",
      },
      create: {
        error: "Beim Anlegen des Benutzers ist ein Fehler aufgetreten.",
        success:
          "Benutzer angelegt. Die Person erhält in Kürze eine E-Mail zum Festlegen des Passworts.",
        title: "Neuen Benutzer anlegen",
      },
      edit: {
        error: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
        record_not_found: "Datensatz nicht gefunden",
        success: "Benutzer erfolgreich aktualisiert",
        title: "%{name} bearbeiten",
      },
      action: {
        new: "Neuer Benutzer",
      },
    },
    tasks: {
      name: "Aufgabe |||| Aufgaben",
      forcedCaseName: "Aufgabe",
      fields: {
        text: "Beschreibung",
        due_date: "Fällig am",
        type: "Typ",
        contact_id: "Kontakt",
        due_short: "fällig",
      },
      action: {
        add: "Aufgabe hinzufügen",
        create: "Aufgabe anlegen",
        edit: "Aufgabe bearbeiten",
      },
      actions: {
        postpone_next_week: "Auf nächste Woche verschieben",
        postpone_tomorrow: "Auf morgen verschieben",
        title: "Aufgabenaktionen",
      },
      added: "Aufgabe hinzugefügt",
      deleted: "Aufgabe erfolgreich gelöscht",
      dialog: {
        create: "Aufgabe anlegen",
        create_for: "Aufgabe für %{name} anlegen",
      },
      sheet: {
        edit: "Aufgabe bearbeiten",
        edit_for: "Aufgabe für %{name} bearbeiten",
      },
      empty: "Noch keine Aufgaben",
      empty_list_hint:
        "Aufgaben, die Sie Ihren Kontakten hinzufügen, erscheinen hier.",
      filters: {
        later: "Später",
        overdue: "Überfällig",
        this_week: "Diese Woche",
        today: "Heute",
        tomorrow: "Morgen",
        with_pending: "Mit offenen Aufgaben",
      },
      regarding_contact: "(Betr.: %{name})",
      updated: "Aufgabe aktualisiert",
    },
    tags: {
      name: "Tag |||| Tags",
      action: {
        add: "Tag hinzufügen",
        create: "Neuen Tag erstellen",
      },
      dialog: {
        color: "Farbe",
        create_title: "Neuen Tag erstellen",
        edit_title: "Tag bearbeiten",
        name_label: "Tag-Name",
        name_placeholder: "Tag-Namen eingeben",
      },
    },
  },
  crm: {
    action: {
      reset_password: "Passwort zurücksetzen",
    },
    auth: {
      first_name: "Vorname",
      last_name: "Nachname",
      confirm_password: "Passwort bestätigen",
      confirmation_required:
        "Bitte folgen Sie dem Link, den wir Ihnen per E-Mail gesendet haben, um Ihr Konto zu bestätigen.",
      login_subtitle: "Zugang zu Ihrem CRM",
      login_title: "Sicherer Login",
      or_divider: "oder",
      recovery_email_sent:
        "Wenn Sie ein registrierter Benutzer sind, erhalten Sie in Kürze eine E-Mail zum Zurücksetzen Ihres Passworts.",
      sign_in_failed: "Anmeldung fehlgeschlagen.",
      sign_in_google_workspace: "Mit Google Workplace anmelden",
      sign_in_oidc: "Mit Agentic360 anmelden",
      signup: {
        create_account: "Konto erstellen",
        create_first_user:
          "Erstellen Sie das erste Benutzerkonto, um die Einrichtung abzuschließen.",
        creating: "Wird erstellt...",
        initial_user_created: "Erster Benutzer erfolgreich erstellt",
      },
      welcome_title: "Willkommen bei Atomic CRM",
    },
    common: {
      account_manager: "Kundenbetreuer",
      activity: "Aktivität",
      added: "hinzugefügt",
      details: "Details",
      last_activity_with_date: "letzte Aktivität %{date}",
      load_more: "Mehr laden",
      misc: "Sonstiges",
      past: "Vergangene Aufgaben",
      read_more: "Mehr anzeigen",
      retry: "Erneut versuchen",
      show_less: "Weniger anzeigen",
      copied: "Kopiert!",
      copy: "Kopieren",
      loading: "Wird geladen...",
      me: "Ich",
      task_count: "%{smart_count} Aufgabe |||| %{smart_count} Aufgaben",
    },
    changelog: {
      title: "Änderungsprotokoll",
    },
    activity: {
      added_company: "%{name} hat ein Unternehmen hinzugefügt:",
      you_added_company: "Sie haben ein Unternehmen hinzugefügt:",
      added_contact: "%{name} hat einen Kontakt hinzugefügt:",
      you_added_contact: "Sie haben einen Kontakt hinzugefügt:",
      added_note: "Notiz von %{name} zu",
      you_added_note: "Ihre Notiz zu",
      added_note_about_deal: "Notiz von %{name} zum Deal",
      you_added_note_about_deal: "Ihre Notiz zum Deal",
      added_deal: "%{name} hat einen Deal hinzugefügt:",
      you_added_deal: "Sie haben einen Deal hinzugefügt:",
      at_company: "bei",
      to: "zu",
      load_more: "Weitere Aktivitäten laden",
    },
    dashboard: {
      deals_chart: "Erwarteter Umsatz aus Deals",
      deals_pipeline: "Deal-Pipeline",
      latest_activity: "Neueste Aktivitäten",
      latest_activity_error: "Fehler beim Laden der neuesten Aktivitäten",
      latest_notes: "Meine neuesten Notizen",
      latest_notes_added_ago: "hinzugefügt %{timeAgo}",
      stepper: {
        install: "Atomic CRM einrichten",
        progress: "%{step}/3 erledigt",
        whats_next: "Wie geht es weiter?",
      },
      upcoming_tasks: "Anstehende Aufgaben",
    },
    data_import: {
      button: "CSV importieren",
      complete:
        "Import abgeschlossen. %{importCount} Datensätze importiert, %{errorCount} Fehler",
      csv_file: "CSV-Datei",
      error:
        "Diese Datei konnte nicht importiert werden. Bitte stellen Sie sicher, dass es sich um eine gültige CSV-Datei handelt.",
      progress:
        "%{importCount} / %{rowCount} Datensätze importiert, %{errorCount} Fehler.",
      remaining_time: "Geschätzte Restzeit:",
      resource: "Ressource",
      running: "Der Import läuft, bitte schließen Sie diesen Tab nicht.",
      sample_download: "CSV-Beispieldatei herunterladen",
      sample_hint:
        "Hier ist eine CSV-Beispieldatei, die Sie als Vorlage verwenden können",
      start: "Import starten",
      stop: "Import abbrechen",
      title: "Daten importieren",
    },
    header: {
      import_data: "Aus JSON importieren",
    },
    image_editor: {
      change: "Ändern",
      drop_hint:
        "Datei zum Hochladen hier ablegen oder klicken, um sie auszuwählen.",
      editable_content: "Bearbeitbarer Inhalt",
      title: "Bild hochladen und Größe anpassen",
      update_image: "Bild aktualisieren",
    },
    import: {
      action: {
        download_error_report: "Fehlerbericht herunterladen",
        import: "Importieren",
        import_another: "Weitere Datei importieren",
      },
      error: {
        unable: "Diese Datei kann nicht importiert werden.",
      },
      idle: {
        description_1:
          "Sie können Benutzer, Unternehmen, Kontakte, Deals, Notizen und Aufgaben importieren.",
        description_2:
          "Die Daten müssen in einer JSON-Datei vorliegen, die dem folgenden Beispiel entspricht:",
      },
      status: {
        all_success: "Alle Datensätze wurden erfolgreich importiert.",
        complete: "Import abgeschlossen.",
        failed: "Fehlgeschlagen",
        imported: "Importiert",
        in_progress: "Import läuft, bitte verlassen Sie diese Seite nicht.",
        some_failed: "Einige Datensätze wurden nicht importiert.",
        table_caption: "Import-Status",
      },
      title: "Aus JSON importieren",
    },
    settings: {
      about: "Über",
      companies: {
        sectors: "Branchen",
      },
      dark_mode_logo: "Logo für den Dunkelmodus",
      deals: {
        categories: "Kategorien",
        currency: "Währung",
        pipeline_help:
          "Wählen Sie aus, welche Deal-Phasen als Pipeline-Deals zählen sollen.",
        pipeline_statuses: "Pipeline-Status",
        stages: "Phasen",
      },
      light_mode_logo: "Logo für den Hellmodus",
      notes: {
        statuses: "Status",
      },
      reset_defaults: "Auf Standardwerte zurücksetzen",
      save_error: "Die Konfiguration konnte nicht gespeichert werden",
      saved: "Konfiguration erfolgreich gespeichert",
      saving: "Wird gespeichert...",
      tasks: {
        types: "Typen",
      },
      preferences: "Persönliche Einstellungen",
      title: "Einstellungen",
      app_title: "Anwendungstitel",
      sections: {
        branding: "Branding",
      },
      validation: {
        duplicate: "%{display_name} doppelt vorhanden: %{items}",
        in_use:
          "%{display_name} können nicht entfernt werden, solange sie von Deals verwendet werden: %{items}",
        validating: "Wird geprüft…",
        entities: {
          categories: "Kategorien",
          stages: "Phasen",
        },
      },
    },
    theme: {
      dark: "Dunkel",
      label: "Design",
      light: "Hell",
      system: "System",
    },
    language: "Sprache",
    navigation: {
      label: "CRM-Navigation",
    },
    profile: {
      inbound: {
        description:
          "Sie können E-Mails an die Eingangsadresse Ihres Servers senden, indem Sie diese zum Beispiel im Feld %{field} eintragen. Atomic CRM verarbeitet die E-Mails und legt Notizen bei den passenden Kontakten an.",
        title: "E-Mail-Eingang",
      },
      mcp: {
        title: "MCP-Server",
        description:
          "Verwenden Sie diese URL, um Ihren KI-Assistenten über das Model Context Protocol (MCP) mit Ihren CRM-Daten zu verbinden.",
      },
      password: {
        change: "Passwort ändern",
      },
      password_reset_sent:
        "Eine E-Mail zum Zurücksetzen des Passworts wurde an Ihre E-Mail-Adresse gesendet",
      record_not_found: "Datensatz nicht gefunden",
      title: "Profil",
      updated: "Ihr Profil wurde aktualisiert",
      update_error:
        "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    },
    validation: {
      invalid_url: "Muss eine gültige URL sein",
      invalid_linkedin_url: "Die URL muss von linkedin.com stammen",
    },
  },
} satisfies CrmMessages;
